import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { Recipient } from '@/lib/types/recipients';

interface RecipientsUIState {
  // Sidepanel (view details)
  selectedRecipient: Recipient | null;
  sidepanelOpen: boolean;
  openSidepanel: (recipient: Recipient) => void;
  closeSidepanel: () => void;
  updateSelectedRecipient: (updates: Record<string, unknown>) => void;

  // Edit sidepanel
  editRecipient: Recipient | null;
  editSidepanelOpen: boolean;
  openEditSidepanel: (recipient: Recipient) => void;
  closeEditSidepanel: () => void;

  // Add modal/sidepanel
  addOptionsModalOpen: boolean;
  addSidepanelOpen: boolean;
  setAddOptionsModalOpen: (open: boolean) => void;
  setAddSidepanelOpen: (open: boolean) => void;

  // Export
  exportDialogOpen: boolean;
  selectedIdsForExport: string[];
  openExportDialog: (ids: string[]) => void;
  closeExportDialog: () => void;
}

export const useRecipientsUIStore = create<RecipientsUIState>()(
  devtools(
    (set) => ({
      selectedRecipient: null,
      sidepanelOpen: false,
      openSidepanel: (recipient) => set({ selectedRecipient: recipient, sidepanelOpen: true }),
      closeSidepanel: () => set({ selectedRecipient: null, sidepanelOpen: false }),
      updateSelectedRecipient: (updates) =>
        set((state) => ({
          selectedRecipient: state.selectedRecipient
            ? ({ ...state.selectedRecipient, ...updates } as Recipient)
            : null,
        })),

      editRecipient: null,
      editSidepanelOpen: false,
      openEditSidepanel: (recipient) => set({ editRecipient: recipient, editSidepanelOpen: true }),
      closeEditSidepanel: () => set({ editRecipient: null, editSidepanelOpen: false }),

      addOptionsModalOpen: false,
      addSidepanelOpen: false,
      setAddOptionsModalOpen: (open) => set({ addOptionsModalOpen: open }),
      setAddSidepanelOpen: (open) => set({ addSidepanelOpen: open }),

      exportDialogOpen: false,
      selectedIdsForExport: [],
      openExportDialog: (ids) => set({ exportDialogOpen: true, selectedIdsForExport: ids }),
      closeExportDialog: () => set({ exportDialogOpen: false, selectedIdsForExport: [] }),
    }),
    { name: 'RecipientsUIStore' },
  ),
);
